import { dew as _isHexDew } from "../data/isHex.js";
import { dew as _sizeDew } from "../data/size.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.isHash = void 0;
  const isHex_js_1 = _isHexDew();
  const size_js_1 = _sizeDew();
  function isHash(hash) {
    return (0, isHex_js_1.isHex)(hash) && (0, size_js_1.size)(hash) === 32;
  }
  exports.isHash = isHash;
  //# sourceMappingURL=isHash.js.map
  return exports;
}